
import $axios from '@/plugins/axiosInstance'

// import axios from 'axios';

// axios.defaults.withCredentials = true;

export default {
 
        listBirims() {
      return $axios.get('Birim');
    },

  

 
  };